import { Howler, Howl } from 'howler';

const audio = {
  sounds: [
    {
      id: 'background',
      file: '/sound/background.mp3',
      ref: null,
      loop: true,
      volume: 0.45,
    },
    {
      id: 'click',
      file: '/sound/click.mp3',
      ref: null,
      loop: false,
      volume: 0.2,
    }, {
      id: 'right',
      file: '/sound/right_answer.mp3',
      ref: null,
      loop: false,
      volume: 0.15,
    }, {
      id: 'wrong',
      file: '/sound/wrong_answer.mp3',
      ref: null,
      loop: false,
      volume: 0.2,
    }, {
      id: 'next',
      file: '/sound/next.mp3',
      ref: null,
      loop: false,
      volume: 0.2,
    }, {
      id: 'result',
      file: '/sound/result.mp3',
      ref: null,
      loop: false,
      volume: 0.5,
    },
  ],

  init() {
    audio.sounds.forEach((s) => { s.ref = new Howl({ src: [s.file], loop: s.loop, volume: s.volume }); });
  },

  get(id) {
    return audio.sounds.find((s) => s.id === id).ref;
  },

  play(id) {
    audio.get(id).play();
  },

  mute() {
    Howler.mute(true);
  },

  unmute() {
    Howler.mute(false);
  },
};

export default audio;
